
import {propertyExists} from './usefull';
import { getStore } from '../redux/store' 

// overrride sound with create js to catch errors

otuApp.playSound = createjs.Sound.play;
createjs.Sound.play = function ( ...args) {
	try {
		return otuApp.playSound( ...args );
	} catch (e) {
		console.log('Sound - Play failed',e);
	}
}



/*
 * Define the global fx animation queue
 * there are fancier ways of doing this but this works
 * now you can call otuApp.fxQ.queue(function(next){...;next();) to queue animations.
 * This will allow us to stop looping animations on step changes and allow you
 * to queue animations that start after others you don't control 
 * such as the page change slides 
 */
otuApp.fxQ=$({});
otuApp.popupQ=$({});
otuApp.gsapTLs=[];
otuApp.endingSong=null;
otuApp.getPreloadedObject = function(key) {
	return preloadedObjects[key];
}

// sounds in fxSounds will be ended on otu.stopAnimations(),
otuApp.fxSounds=[];

var preloadedSounds=[]; // id's 
var preloadedImages=[]; // id's
var preloadedObjects=[] // actual loaded objects


//var preloadQueue=array();

var seaSound={obj:null,playing:false};

var UILoading = {
		elements:[],
		showing:false
}

/*
 * Songs for the radio must be available in both ogg and mp3 in the sounds directory
 * radio state tells us which song is playing.
 */
var radioSongs=[
	 	{
	 		song:"Mr-Tone-6-2B-FIT-Know-Your-Nutrients-Theme-Song",
	 		title:"Know Your Nutrient Theme Song",
	 		obj:null	
	 	},
	 	{	song:"Mr-Tone-Put-your-Mind-into-it",
	 		title:"Put Your Mind Into It",
	 		obj:null
	 	}
	 ];


otuApp.radioState= {
		songDir:'templates/op/assets/sounds/',
		playing:false,
		index:0,
		title:"Not Playing",
		startPreload:false,
		volume:0.4
}

otuApp.fxOptions = {
		stepChangeDuration:500,
		mapFadeInDuration:0,
		mapFadeOutDuration:0,
		soundPath:'templates/op/assets/sounds/',
		imagePath:'templates/op/assets/images/',
		messageSoundVolume:0.5,
		answerSoundVolume:0.3,
		tickingClockVolume:0.1,
		newMessageVolume:0.1
}

// register the media plugin order and the cordova plugin if required
if (otuApp.isCordovaApp() && false) {
	console.log('Cordova - Animate Registering CordovaAudioPlugin (SoundJs)');
	createjs.Sound.registerPlugins([createjs.CordovaAudioPlugin,createjs.HTMLAudioPlugin]);
}


/*
 * returns the perc widht and height  
 */

$.fn.percWidth = function(){
	return this.outerWidth() / $(window).width() * 100;
}

$.fn.percHeight = function(){
	return this.outerHeight() / $(window).height() * 100;
}

/*
 * General Hover Effect Function
 */ 
otuApp.animateOnHover = function (element, animation){

  element = $(element);
  element.hover(
    function() {
      $(this).addClass('animated ' + animation);
    },
    function(){
      var e = $(this);
      //wait for animation to finish before removing classes
      window.setTimeout( function(){
        e.removeClass('animated ' + animation);
      }, 2000);
    }
  );
  return true;
}

otuApp.fadeOutTitle = function (el){
	el = el || '.leaflet-marker-pane h1';
	$(el).delay(5000).fadeOut(500);
}

/*
 * Plays the sea sounds
 */

otuApp.playSeaSounds = function () {

	const reduxState = getStore().getState();

	if ( reduxState.otuVision.onCall ) {
		seaSound.playing=false;

		return
	}

	// This will play some sea sounds made with naturesoundsforme
	function waveDown() {
		//$(seaSound).animate({volume: 0.2}, 15000, 'swing', waveUp);
		TweenLite.to(seaSound.obj,15,{volume:0.2,onComplete:waveUp});
	}	
	function waveUp(){
		//$(seaSound).animate({volume: 0.4}, 15000, 'swing', waveDown);	
		TweenLite.to(seaSound.obj,15,{volume:0.4,onComplete:waveDown});

	}	
	seaSound.playing=true;
	
	otuApp.preload({sounds:['sea']}, function() {
		console.log('Sounds - Animate start seaSound');
		if (seaSound.obj===null && seaSound.playing)
			seaSound.obj=createjs.Sound.play('sea',{volume:0,loop:-1});
			if (!seaSound.obj) 	seaSound.playing=false;

		else {
			if (seaSound.playing && seaSound.obj) 
				seaSound.obj.play();
		}
		
		if (seaSound.playing && seaSound.obj) TweenLite.to(seaSound.obj,10,{volume:0.4,onComplete:waveDown});

	});

}

otuApp.stopSeaSounds = function () {
	
	if (seaSound.obj!=null)	{
		TweenLite.killTweensOf(seaSound.obj);
		seaSound.obj.stop();
	}

	seaSound.playing=false;

}


/*
function playSound(ele, Options) {	
	var options = {volume:0.4};
	$.extend(options,Options );
	ele.prop("volume", options.volume);
	ele.trigger('play');
	console.log('start audio' + ele);
	return (ele);
	
}

function stopSound(ele,Options ) {
	var options = {};
	$.extend(options,Options)			
	ele.trigger('pause');
	ele.get(0).currentTime = 0;
	console.log('stopped audio' + ele);	
}

*/
otuApp.loadRadio = function () {
	console.log('Radio - Animate loading Radio');
	
	var audio=null;
	
	otuApp.radioState.startPreload=true;
	
	//createjs.Sound.registerPlugins([createjs.HTMLAudioPlugin,createjs.WebAudioPlugin]);
	createjs.Sound.alternateExtensions = ["mp3"];
	for (let i = 0; i < radioSongs.length; ++i) {
		console.log('Radio - Animate loading song' + radioSongs[i].song)
		preloadedSounds.push(radioSongs[i].song);
    	createjs.Sound.registerSound(otuApp.appState.rootUrl + otuApp.radioState.songDir + radioSongs[i].song + '.ogg', radioSongs[i].song);		  
	}
	
}

otuApp.preload = function (Options,callback) {	
	
	var localCallback=function(){
		console.log('Preload - Queue callback');
		otuApp.hideLoading({id:'preloadMedia'});
		callback();
	}
	
	var localFileLoadCallback=function(event){
		console.log('Preload - Single file load callback ' + event.item.id);
		preloadedObjects[event.item.id]=event.result;
	}
	
	var count=0;
	
	var options = {
			sounds:[],
			images:[],
			fullImgPath:false
			};
	$.extend(options,Options);
	
	createjs.Sound.alternateExtensions = ["mp3"];

	//if (preloadQueue===null) {
	var	preloadQueue = new createjs.LoadQueue();
	 	preloadQueue.installPlugin(createjs.Sound);
	 	preloadQueue.on("complete", localCallback, this);
	 	preloadQueue.on("fileload", localFileLoadCallback, this);

	var snds=options.sounds; 
	for (let i = 0; i < snds.length; ++i) {
		if ($.inArray(snds[i], preloadedSounds) === -1) {
			console.log('Preload - Animate preloading sound ' + snds[i] + ' ' + otuApp.appState.rootUrl + otuApp.fxOptions.soundPath + snds[i] + '.ogg');			
			count++;
			preloadedSounds.push(snds[i])
			preloadQueue.loadFile({id:snds[i], src:otuApp.appState.rootUrl + otuApp.fxOptions.soundPath + snds[i] + '.ogg'},
					false);
		}
	}
	
	var imgs=options.images; 
	for (let i = 0; i < imgs.length; ++i) {
		if ($.inArray(imgs[i], preloadedImages) === -1) {
			console.log('Preload - Animate preloading images ' + imgs[i]);
			count++;
			preloadedImages.push(imgs[i])
			if (options.fullImgPath) {
				preloadQueue.loadFile({id:imgs[i], src:imgs[i]});
			} else {
				preloadQueue.loadFile({id:imgs[i], src:otuApp.appState.rootUrl + otuApp.fxOptions.imagePath + imgs[i]},
						false);				
			}	
		}
	}
	
	
	// if we haven't loaded anything ret.urn the callback
	if (count===0) {
		callback();} 
	else { 
		otuApp.showLoading({id:'preloadMedia'});
		preloadQueue.load();
	}
	
	
}

otuApp.playRadio = function (Options) {
	var options = {};
	$.extend(options,Options)
	
	console.log('Radio - Animate play radio');
	
	// already playing , exit
	if (otuApp.radioState.playing) return true;
	
	
	// start loading the songs if we have not loaded them yet
	if (!otuApp.radioState.startPreload) {
		otuApp.loadRadio();
	}
	
	var song=radioSongs[otuApp.radioState.index].song;
	if (song.length) {
		if (radioSongs[otuApp.radioState.index].obj===null)
			radioSongs[otuApp.radioState.index].obj=createjs.Sound.play(radioSongs[otuApp.radioState.index].song);
		else	
			radioSongs[otuApp.radioState.index].obj.play();
			
		otuApp.radioState.title=radioSongs[otuApp.radioState.index].title;
		otuApp.radioState.playing=true;	
	}
}

otuApp.nextRadioSong= function (Options) {
	var options = {loop:false};
	$.extend(options,Options);
	
	//var count=$('#radio audio').length;
	
	if (!otuApp.radioState.playing) return true;
	radioSongs[otuApp.radioState.index].obj.stop();

	if ((otuApp.radioState.index+1)<radioSongs.length) { 
		otuApp.radioState.index++;
	} else  {
		otuApp.radioState.index=0;
	}
			
	// got to the end and we are not looping, so stop it
	if (!options.loop && otuApp.radioState.index===0 ) {
		otuApp.radioState.playing=false;	
		console.log('Radio - Animate stop radio');
		return true;
	}
	
	if (otuApp.radioState.index!==0) {
		if (radioSongs[otuApp.radioState.index].obj==null)
			radioSongs[otuApp.radioState.index].obj=createjs.Sound.play(radioSongs[otuApp.radioState.index].song)
		else	
			radioSongs[otuApp.radioState.index].obj.play();
	}

}

otuApp.stopRadio = function (Options) {
	var options = {loop:false};
	$.extend(options,Options);
	
	if (!otuApp.radioState.playing) return true;
	otuApp.radioState.playing=false;
	radioSongs[otuApp.radioState.index].obj.stop();
	otuApp.radioState.index=0

	return true;
	
}

otuApp.fullScreen=false;

otuApp.toggleFullscreen = function (element) {
	if (!otuApp.fullScreen) {
		launchIntoFullscreen(element);
		otuApp.fullScreen=true;
	} else {
		exitFullscreen();
		otuApp.fullScreen=false;
	}
}

function launchIntoFullscreen(element) {
	  if(element.requestFullscreen) {
	    element.requestFullscreen();
	  } else if(element.mozRequestFullScreen) {
	    element.mozRequestFullScreen();
	  } else if(element.webkitRequestFullscreen) {
	    element.webkitRequestFullscreen();
	  } else if(element.msRequestFullscreen) {
	    element.msRequestFullscreen();
	  }
	}

function exitFullscreen() {
	  if(document.exitFullscreen) {
	    document.exitFullscreen();
	  } else if(document.mozCancelFullScreen) {
	    document.mozCancelFullScreen();
	  } else if(document.webkitExitFullscreen) {
	    document.webkitExitFullscreen();
	  }
	}

otuApp.numberWithCommas=function(x) {
		if ( typeof x ==='undefined' || x === null ) return 0;
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

otuApp.unloadMenuBar=function( options ={}){
	const {
		animate  = true 
	} = options
	// we hide the menubar
	console.log('Menubar - Unload Requested');
	if (otuApp.menuBarInitialized) {
		otuApp.fxQ.queue(function(next) {	

			if ( animate ) {
				$("#" + otuApp.appState.menuBarTemplate).fadeOut(function(){
					otuApp.menuBarInitialized=false;
					$("#" + otuApp.appState.menuBarTemplate).remove();
					console.log('Menubar - Unloaded');
					next();
				});
			} else {
				otuApp.menuBarInitialized=false;
				$("#" + otuApp.appState.menuBarTemplate).remove();
				console.log('Menubar - Unloaded');
				next();
			}

		});
	}
	
}


var updateProgressIndicator= function(Options) {
	var options={};
	$.extend(options,Options );
	var progress=0;
	var indicators = {
		orange:0,
		green:0,
		yellow:0,
		blue:0
	}

	if (!otuApp.appUser.guest && propertyExists(otuApp,'appUser','json','mission1','supplyCount')) {
		//progress=otuApp.appUser.json.mission1.supplyCount/10;

		$('#menubarSuppliesCount').text(otuApp.appUser.json.mission1.supplyCount);
		/*
		indicators.orange=Math.max(0,Math.min(progress*100,25));
		indicators.green=Math.max(0,Math.min(progress*100,50)-25);
		indicators.yellow=Math.max(0,Math.min(progress*100,75)-50);
		indicators.blue=Math.max(0,Math.min(progress*100,100)-75);

		$('.appStudentMenuProgress .progress-bar').css({display:'none'});
	
		if (indicators.orange) {
			$('.appStudentMenuProgress .progress-bar-orange').css({ display:'block', width : indicators.orange + '%'});
		}
		if (indicators.green) {
			$('.appStudentMenuProgress .progress-bar-green').css({ display:'block', width : indicators.green + '%'});
		}
		if (indicators.yellow) {
			$('.appStudentMenuProgress .progress-bar-yellow').css({ display:'block', width : indicators.yellow + '%'});
		}
		if (indicators.blue) {
			$('.appStudentMenuProgress .progress-bar-blue').css({ display:'block', width : indicators.blue + '%'});
		}
		*/

	}	
}

otuApp.updateProgressIndicator = updateProgressIndicator;

otuApp.showLoading= function (options = {}) {
	const {
		id  = null,
		type = 'load', 
	} = options
	
	var index=$.inArray( id, UILoading.elements);

	// if we are in error state we dont show the loading sign
	if (otuApp.errorState) {
		UILoading.showing=false;
		$('.sys-message-modal .loading-message').hide();
		return;
	}

	if (index==-1) {
		UILoading.elements.push(id);
	}
	
	if (!UILoading.showing) {
		console.log('UI Loading - Show loading');
		UILoading.showing=true;
			$('.sys-message-modal').stop(true,true);
			$('.sys-message-modal .sys-message').hide();
			$('.sys-message-modal').removeClass('bg-black');
			switch ( type ) {
				case 'load':
					$('.sys-message-modal .loading-message').show();
					break;
				case 'upload':
					$('#sys-upload-progress').html('');
					$('.sys-message-modal .uploading-message').show();
					break;
			}
			$('.sys-message-modal').fadeIn(500);
	}
	
}

otuApp.hideLoading= function (options) {
	var id=options.id;
	var index=$.inArray( id, UILoading.elements);

	if (otuApp.errorState) {
		UILoading.elements=[];
		UILoading.showing=false;
		$('.sys-message-modal .loading-message').hide();
		$('.sys-message-modal .uploading-message').hide();
		return;
	}

	if (index !==-1) {
		UILoading.elements.splice(index,1);
	}
	
	if (UILoading.elements.length===0 && UILoading.showing) {
		console.log('UI Loading - Hide loading');
			$('.sys-message-modal').stop(true,true);
			$('.sys-message-modal').fadeOut(500);
		UILoading.showing=false;

	}
	
}

otuApp.onFinishedLoading = function (callback) {
	var finishedLoading = new Promise(function(resolve, reject) {
		  function checkFinishedLoading() {
			  if (UILoading.showing===false) {
				console.log('UI Loading - Finished loading')  
				resolve();
			  } else {
				  console.log('UI Loading - checking');
				  setTimeout(checkFinishedLoading,1000);
			  }
		  }
		  checkFinishedLoading();
		  
	});
	
	finishedLoading.then(callback);
}



